import { useEffect, useState } from "react";
import { api } from "./api";

const cache = {};

const load = (sport) => {
  if (!sport) return Promise.resolve({});
  if (!cache[sport]) {
    cache[sport] = api.get("/team-logos", { params: { sport } }).then((r) => r.data).catch(() => {
      delete cache[sport];
      return {};
    });
  }
  return cache[sport];
};

// {abbr: logoUrl} for a sport (ESPN logos matched to our teams), shared across the app.
export const useTeamLogos = (sport) => {
  const [map, setMap] = useState({});
  useEffect(() => {
    let alive = true;
    load(sport).then((m) => alive && setMap(m));
    return () => { alive = false; };
  }, [sport]);
  return map;
};
